import React from "react";

class LoginIcon extends React.Component {
  render() {
    return (
      <i className="anticon anticon-profile">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="1.18em"
          height="1em"
          viewBox="0 0 17 18"
        >
          <path
            id="Forma_1"
            data-name="Forma 1"
            d="M76.52,234.951l-0.853.874a1.592,1.592,0,0,1-2.131,0l-0.426-.437-1.172,1.2a1.592,1.592,0,0,1-2.132,0l-0.853-.874a1.483,1.483,0,0,1,0-2.185l1.172-1.2L67.461,229.6a4.52,4.52,0,0,1-2.025.438,5.363,5.363,0,0,1-4.37-2.295,5.541,5.541,0,0,1-.213-6.227A5.673,5.673,0,0,1,65.437,219a5.168,5.168,0,0,1,3.837,1.639,5.67,5.67,0,0,1,1.172,5.9l6.075,6.228A1.483,1.483,0,0,1,76.52,234.951Zm-0.639-1.421-6.394-6.554a0.525,0.525,0,0,1-.107-0.656,4.607,4.607,0,0,0-.853-5.026,4.216,4.216,0,0,0-3.091-1.311,4.266,4.266,0,0,0-3.623,2.076,4.536,4.536,0,0,0,.107,5.026,4.267,4.267,0,0,0,3.517,1.857,2.734,2.734,0,0,0,1.918-.656,0.474,0.474,0,0,1,.639.11l3.3,3.386a2.56,2.56,0,0,1,.107.437,0.536,0.536,0,0,1-.107.437L69.7,234.3a0.413,0.413,0,0,0,0,.656l0.853,0.874a0.392,0.392,0,0,0,.639,0l1.6-1.639a0.507,0.507,0,0,1,.746,0l0.853,0.874a0.391,0.391,0,0,0,.639,0l0.853-.874A0.413,0.413,0,0,0,75.881,233.53ZM63.945,226.1a2.149,2.149,0,0,1,0-3.059,2.027,2.027,0,0,1,2.984,0,2.149,2.149,0,0,1,0,3.059A2.023,2.023,0,0,1,63.945,226.1Zm2.238-2.294a1.069,1.069,0,0,0-1.492,1.53,1.014,1.014,0,0,0,1.492,0A1.075,1.075,0,0,0,66.183,223.807Z"
            transform="translate(-60 -219)"
            fill="currentColor"
          />
        </svg>
      </i>
    );
  }
}

export default LoginIcon;
